import * as React from "react";

interface OwnProps {
}

interface OwnState {
}

export class EmailBody extends React.Component<OwnProps, OwnState> {

    public constructor(props: OwnProps) {
        super(props);
    }

    public render() {

        return <div id="e">
            <p>
                <img alt="The American Society of Retina Specialists" height="47" src="http://www.asrs.org/content/images/asrs-logo-small-email.png" width="289"/>
            </p>

            <br />

            {this.props.children}

            <div id="footer">
                <small>
                The American Society of Retina Specialists
                <br/>20 North Wacker Drive, Suite 2030, Chicago, IL 60606 | Phone 312.578.8760
                </small>
            </div>
        </div>;
    }
}



// WEBPACK FOOTER //
// ./src/components/page/EmailBody.tsx